import { RequestDefinition } from 'libraries/front-end-core/core/Api'

import {
  toUser,
  toUserAuth,
  toSearchHistory,
  toTracking,
  toEmailPreferences,
  toAolOrderPreferences,
  toPrimaryAol,
  toPractisingAol
} from './transforms'

import {
  URL_USER,
  URL_USER_AUTH,
  URL_SEARCH_HISTORY,
  URL_TRACKING,
  URL_EMAIL_PREFERENCES,
  URL_AOL_PREFERENCES,
  URL_PRIMARY_AOL,
  URL_PRACTISING_AOL
} from 'constants/urls'

import {
  USER,
  USER_AUTH,
  SEARCH_HISTORY,
  TRACKING,
  EMAIL_PREFERENCES,
  AOL_ORDER_PREFERENCES,
  PRIMARY_AOL,
  PRACTISING_AOL
} from 'constants/requests'

export const User = new RequestDefinition({
  name: USER,
  url: URL_USER,
  transform: toUser
})

export const EmailPreferences = new RequestDefinition({
  name: EMAIL_PREFERENCES,
  url: URL_EMAIL_PREFERENCES,
  transform: toEmailPreferences
})

export const UserAuth = new RequestDefinition({
  name: USER_AUTH,
  url: URL_USER_AUTH,
  transform: toUserAuth
})

export const SearchHistory = new RequestDefinition({
  name: SEARCH_HISTORY,
  url: URL_SEARCH_HISTORY,
  transform: toSearchHistory
})

export const Tracking = new RequestDefinition({
  name: TRACKING,
  url: URL_TRACKING,
  transform: toTracking
})

export const AolOrderPreferences = new RequestDefinition({
  name: AOL_ORDER_PREFERENCES,
  url: URL_AOL_PREFERENCES,
  transform: toAolOrderPreferences
})

export const PrimaryAolPreference = new RequestDefinition({
  name: PRIMARY_AOL,
  url: URL_PRIMARY_AOL,
  transform: toPrimaryAol
})

export const PractisingAolPreference = new RequestDefinition({
  name: PRACTISING_AOL,
  url: URL_PRACTISING_AOL,
  transform: toPractisingAol
})
